import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { UserMasterEffects } from './effects/user-master.effects';
import { userMasterReducer } from './reducers/user-master.reducer';
import { selectSelectedUser } from './selectors/user-master.selector';
import { USER_MASTER_FEATURE_KEY } from './user-master-collection.state';

/**
 * Registers the user-master feature slice and its init effect. The selection is resolved
 * through {@link UserMasterEffects} (rehydrate-or-fetch), and the slice registers its
 * projection selector so the generic persistence layer can save/restore it by feature key.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(USER_MASTER_FEATURE_KEY, userMasterReducer),
        EffectsModule.forFeature([UserMasterEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: { featureKey: USER_MASTER_FEATURE_KEY, persistSelector: selectSelectedUser },
        },
    ],
})
export class UserMasterStoreModule {}
